import React, { type ReactNode } from 'react';

import { Action, Text, colors } from '@soluto-private/mx-asurion-ui-react';

export const ClickableText: React.FC<{
  children?: ReactNode;
  color?: string;
  label?: string;
  onClick?: () => void;
  target?: string;
  url?: string;
}> = ({ children, color, label, onClick, target = '_blank', url }) => {
  return (
    <Action
      data-analytics-action-id={label}
      data-analytics-cta={label}
      data-analytics-step-name={label}
      href={url}
      onClick={onClick}
      style={{ color: color ?? colors.neutralDeeper }}
      target={target}
      variant="flat"
    >
      <Text
        as="h2"
        color={color ?? colors.neutralDeeper}
        data-testid="step-subtitle"
        size={2}
      >
        {children}
      </Text>
    </Action>
  );
};
